import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../common/forms/FormItem';
import { isRequired } from '../../../../utils/validators';
import RegisteredBusSelect from '../../../common/forms/select/RegisteredBusSelect';
import Loader from '../../../common/Loader';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';
import CircuitSelect from '../../../common/forms/select/CircuitSelect';

const BusAssignmentScheduleForm = ({
  handleSubmit,
  loading,
  initialValues,
}) => {
  if (loading) return <Loader />;
  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Circuito Asignados" required>
          <Field
            name="circuit"
            component={CircuitSelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Buses Asignados" required>
          <Field
            name="busList"
            component={RegisteredBusSelect}
            validate={[isRequired]}
            isMulti
            onlyActive
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Fecha de Inicio" required>
          <Field
            name="startDate"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Fecha de Fin" required>
          <Field
            name="endDate"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {initialValues && (
        <FormGroup row>
          <FormItem label="Activo">
            <Field name="active" component="input" type="checkbox" />
          </FormItem>
        </FormGroup>
      )}
      <FormFooter />
    </Form>
  );
};

BusAssignmentScheduleForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({
    active: PropTypes.bool,
  }),
};

BusAssignmentScheduleForm.defaultProps = {
  initialValues: null,
};

const mapStateToProps = ({ BusUnit }) => ({
  loading: !BusUnit.BusAssignmentSchedule.getIn([
    'current',
    'loading',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'busAssignmentScheduleForm',
})(BusAssignmentScheduleForm);

export default connect(mapStateToProps)(formComponent);
